import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from '@emotion/styled';
const InputWrapper = styled.div `
  display: ${({ fullWidth }) => (fullWidth ? 'flex' : 'inline-flex')};
  flex-direction: column;
  gap: 0.375rem;
  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
`;
const Label = styled.label `
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
`;
const StyledInput = styled.input `
  padding: 0.5rem 0.75rem;
  font-size: 0.9375rem;
  background: ${({ theme }) => theme.colors.bg.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  border: 1px solid
    ${({ theme, hasError }) => hasError ? theme.colors.error : theme.colors.border.default};
  border-radius: 0.5rem;
  transition: border-color 150ms ease, box-shadow 150ms ease;
  width: 100%;
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.text.tertiary};
  }

  &:focus {
    border-color: ${({ theme, hasError }) => hasError ? theme.colors.error : theme.colors.brand.primary};
    box-shadow: 0 0 0 3px
      ${({ theme, hasError }) => hasError ? `${theme.colors.error}20` : `${theme.colors.brand.primary}20`};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: ${({ theme }) => theme.colors.bg.tertiary};
  }
`;
const HelperText = styled.span `
  font-size: 0.75rem;
  color: ${({ theme, error }) => error ? theme.colors.error : theme.colors.text.tertiary};
`;
export const Input = forwardRef(({ label, helperText, error, fullWidth = true, ...props }, ref) => {
    return (_jsxs(InputWrapper, { fullWidth: fullWidth, hasError: !!error, children: [label && _jsx(Label, { children: label }), _jsx(StyledInput, { ref: ref, hasError: !!error, ...props }), (error || helperText) && _jsx(HelperText, { error: !!error, children: error || helperText })] }));
});
Input.displayName = 'Input';
//# sourceMappingURL=Input.js.map